import { FancyInput } from 'components/ui/Inputs';
import React from 'react';
import { setReferenceNumber } from 'redux/services/twittlebugs/sparingParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const ReferenceFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setReferenceNumber(value || undefined));
  }, 500);

  return <FancyInput placeholder="Primary Reference Number" onChange={handleChange} allowClear />;
};
